export const ACTIVITY_TYPES_SHIFT_DATA: string[] = [
  'Dispatch',
  'Splunk Alert',
  'Call - Inbound',
  'Call - Outbound',
  'Email',
  'Platform Outage',
  'Alert',
  'Process',
  'STAT',
  'DRT',
  'Day Ahead Dispatch',
  'UFE',
  'Exception',
  'Event Cancelled',
  'Site Arm/Disarmed',
  'Opt-Out',
  'Opt-In',
  'Other',
  'TOGGLED',
  'UFE',
  'RESTORED',
  'CANCELLED',
  'ARM/DISARM',
  'Opt-Out',
  'Opt-In',
  'AUDIT WINDOW',
  'DISPATCH DAY',
  'Program Holiday',
  'Dispatch End',
  'STAT',
  'Offers Change',
  'TPC Forced Outage',
];

export const ACTIVITY_TYPES_HANDOVER_DATA: string[] = ['Actionable', 'Need-to-know'];
